import React from 'react';
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Stack,
  Link,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';

const Home = () => {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 10,
          textAlign: 'center',
        }}
      >
        <Typography variant="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
          HYPERD
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
          기술과 사람을 잇는 최고의 솔루션을 제공합니다.
        </Typography>
        <Button variant="contained" size="large" color="secondary">
          자세히 알아보기
        </Button>
      </Box>

      {/* Feature Cards */}
      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          {[
            {
              title: '스마트 솔루션',
              description: 'AI 기반 맞춤형 서비스로 비즈니스 효율을 극대화합니다.',
              image: 'logo.png',
            },
            {
              title: '글로벌 네트워크',
              description: '전 세계와 연결된 강력한 파트너십 구축.',
              image: '/images/space.jpg',
            },
            {
              title: '지속 가능한 경영',
              description: '환경과 사회를 고려한 지속 가능한 전략을 추구합니다.',
              image: '/images/n.png',
            },
          ].map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card sx={{ height: '100%' }}>
                <CardMedia
                  component="img"
                  height="180"
                  image={item.image}
                  alt={item.title}
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom>{item.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Vision Section */}
      <Box sx={{ bgcolor: 'grey.100', py: 8 }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
              <img
                src="/Images/playstore.jpg"
                alt="비전 이미지"
                style={{ width: '100%', maxWidth: 250, borderRadius: 20, boxShadow: '0px 4px 20px rgba(0,0,0,0.1)' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                우리의 비전
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                우리는 기술을 통해 사람들의 삶을 더욱 편리하게 만들고,
                기업의 미래를 함께 설계합니다. 창의성, 신뢰, 지속 가능성을
                핵심 가치로 삼습니다.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* FAQ Section */}
      <Container sx={{ py: 8 }}>
        <Typography variant="h4" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
          자주 묻는 질문 (FAQ)
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: 'medium' }}>서비스는 어떤 기업에 적합한가요?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="text.secondary">
              스타트업부터 대기업까지, 다양한 산업 분야의 기업에 최적화된 서비스를 제공합니다.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: 'medium' }}>도입 비용은 어떻게 되나요?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="text.secondary">
              맞춤형 견적을 통해 안내드리고 있습니다. 아래 고객 지원 센터로 문의 주시면 빠르게 상담해드립니다.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Container>

      {/* --- Apple Review 대응: Customer Support Section --- */}
      <Box sx={{ bgcolor: 'white', py: 8, borderTop: '1px solid #eee' }}>
        <Container maxWidth="sm">
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            Customer Support
          </Typography>
          <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 4 }}>
            앱 이용 중 궁금하신 점이나 도움이 필요하시면 언제든 연락주세요.
          </Typography>
          
          <Stack spacing={3}>
            {/* 이메일 섹션 */}
            <Card variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
              <EmailIcon sx={{ mr: 2, color: 'primary.main' }} />
              <Box>
                <Typography variant="subtitle2" color="text.secondary">Email Support</Typography>
                <Link href="mailto:hyperd628@gmail.com" underline="hover" sx={{ fontWeight: 'bold' }}>
                  hyperd628@gmail.com
                </Link>
              </Box>
            </Card>

            {/* 인스타그램 섹션 */}
            <Card variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
              <InstagramIcon sx={{ mr: 2, color: '#E1306C' }} />
              <Box>
                <Typography variant="subtitle2" color="text.secondary">Instagram</Typography>
                <Link href="https://www.instagram.com/gerno0613" target="_blank" underline="hover" sx={{ fontWeight: 'bold' }}>
                  @gerno0613
                </Link>
              </Box>
            </Card>
          </Stack>
        </Container>
      </Box>

      {/* Bottom CTA */}
      <Box
        sx={{
          bgcolor: 'secondary.main',
          color: 'white',
          py: 8,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
          지금, 우리와 함께 새로운 변화를 시작해보세요.
        </Typography>
        <Button 
            variant="contained" 
            color="primary" 
            size="large" 
            href="mailto:hyperd628@gmail.com"
            sx={{ mt: 2 }}
        >
          상담 신청하기 (이메일 문의)
        </Button>
      </Box>
    </Box>
  );
};

export default Home;